import * as XLSX from 'xlsx';

export const downloadPremiacaoImportLayout = (layoutColumns, fileName) => {
  const headers = layoutColumns.map((coluna) => coluna.nome);
  const worksheet = XLSX.utils.aoa_to_sheet([headers]);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Layout');
  XLSX.writeFile(workbook, fileName);
};

export const downloadPremiacaoImportLayoutBlob = (blob, fileName) => {
  const arquivo = blob instanceof Blob
    ? blob
    : new Blob([blob], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

  const url = window.URL.createObjectURL(arquivo);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.click();
  window.URL.revokeObjectURL(url);
};
